import React, { useState, useEffect, useRef } from "react";
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  InputGroup,
  OverlayTrigger,
  Tooltip,
} from "react-bootstrap";
import { Link, useHistory, useParams } from "react-router-dom";
import UserService from "../../services/user.service";
import Modal from "react-bootstrap/Modal";
import moment from "moment";
import Loading from "../../common/Loading";
import ToastBlockContainer from "../../common/ToastBlockContainer";
import { element } from "prop-types";

const Savings = (props) => {
  const myRef = useRef(null);
  let history = useHistory();
  let { uuid, userUUID } = useParams();
  const UserDetails = JSON.parse(localStorage.getItem("UserDetails"));

  const [familyDetails, setFamilyDetails] = useState([]);
  const [successToast, setSuccessToast] = useState(false);
  const [savingsList, setSavingsList] = useState([]);
  const [searchStr, setSearchStr] = useState("");
  const [showSearchText, setShowSearchText] = useState(false);
  const [showSearch, setShowSearch] = useState(false);
  const [addSavingsURL, setAddSavingsURL] = useState("");
  const [title, setTitle] = useState("Life Accounts");
  const [isEmpty, setIsEmpty] = useState(false);
  const [showToast, setShowToast] = useState(false);
  const [toastMessage, setToastMessage] = useState("");
  const [limit, setlimit] = useState(50);
  const [offset, setOffset] = useState(0);
  const [familyUserId, setFamilyUserId] = useState();
  const [monthType, setMonthType] = useState("all");
  const [checkAll, setCheckAll] = useState(true);
  const [filtValue, setfiltValue] = useState("all"); // filter by
  const [expValue, setexpValue] = useState(""); // status by
  const [searchValue, setsearchValue] = useState(""); // search by
  const [sortValue, setsortValue] = useState("createdAt"); //sort by
  const [orderValue, setorderValue] = useState("DESC"); //order by
  const [loadingspinner, setLoadingspinner] = useState(true);
  const [currentPage, setCurrentPage] = useState(1);
  const [totalItems, setTotalItems] = useState(0); // Total items, needed to calculate total pages
  const [mounted, setMounted] = useState(false); // Tracks if the component has fully loaded
  const [isDropdownOpen, setIsDropdownOpen] = useState(false);
  const [isDropdownOpen1, setIsDropdownOpen1] = useState(false);
  const [selectedFilterType, setSelectedFilterType] = useState(null);
  const [screenWidth, setScreenWidth] = useState(window.innerWidth);
  const [haveAccessView, setHaveAccessView] = useState(false);
  const [haveAccessAdd, setHaveAccessAdd] = useState(false);

  const [selectedOption1, setSelectedOption1] = useState({
    value: "all",
    label: "All Accounts",
  }); // Selected option for first dropdown
  const filterOption = [{ value: "all", label: "All Accounts" }];
  const [isDropdownOpen2, setIsDropdownOpen2] = useState(false);
  const [sortOptSelected, setSortOptSelected] = useState({
    value: "DESC",
    label: "Descending",
  });
  const sortMain = [{ value: "status", label: "By Sort" }];
  const sortOpt = [
    { value: "DESC", label: "Descending" },
    { value: "ASC", label: "Ascending" },
  ];
  const viewDetailsRoute = (savingsId) => {
    if (userUUID) {
      history.push(
        `/view_user_savings_details/${uuid}/${savingsId}/${userUUID}`
      );
    } else {
      history.push(`/view_savings_details/${uuid}/${savingsId}`);
    }
  };
  const editSavingsUrl = (savingsId) => {
    if (userUUID) {
      history.push(`/edit_user_savings/${uuid}/${savingsId}/${userUUID}`);
    } else {
      history.push(`/edit_savings/${uuid}/${savingsId}`);
    }
  };

  useEffect(() => {
    if (userUUID) {
      UserService.userProfile(userUUID).then((response) => {
        setAddSavingsURL("/add_user_savings/" + uuid + "/" + userUUID);
        getFamilyDetails(response.userData.id);
        setTitle(`Life Accounts`);
      });
    } else {
      setAddSavingsURL("/add_savings/" + uuid);
      getFamilyDetails(UserDetails.id);
    }
  }, []);

  const getFamilyDetails = (userId) => {
    UserService.relationData(uuid).then((respo) => {
      // main user checking
      const mainUser = respo.data.au.find(
        (obj) => obj.User.email === UserDetails.email
      );

      const mainArr = [];
      if (mainUser) {
        mainArr.push(mainUser);
      }

      // support user checking
      const suppUser = respo.data.au.find((obj) =>
        obj.su.find(
          (family) =>
            family.Family_User &&
            family.Family_User.User.email === UserDetails.email
        )
      );

      const suppArr = [];
      if (suppUser) {
        suppArr.push(suppUser);
      }

      let newArray = [];
      newArray = [...mainArr, ...suppArr];
      console.log(mainArr);
      console.log(suppArr);
      console.log(newArray);

      const uuidFind = newArray.find((obj) => obj.User.uuid === userUUID);
      console.log(uuidFind);
      UserService.getUserSingleFamilyDetails(uuid, userId).then(
        (response) => {
          //
          console.log(response);
          let payLoad = {
            FamilyId: response.FamilyData.Family.id,
            FamilyUserId: response.FamilyData.id,
          };
          console.log(typeof userUUID);
          UserService.savingsAuthUsers(payLoad).then((respo) => {
            var res = respo.viewableData[0];
            console.log(res);
            if (userUUID === undefined) {
              debugger;
              setHaveAccessAdd(true);
              setHaveAccessView(true);
            } else {
              debugger;
              // console.log(element);
              const newEl = newArray[0].su.find(
                (element) =>
                  element.Family_User.User.email === UserDetails.email
              );
              console.log(newEl);
              let addAccess = false;
              let viewAccess = false;

              if (
                res.addPrevilege === "any_one" ||
                res.addPrevilege === "all_su" ||
                (res.addableUsers.includes(newEl?.FamilyUserId) &&
                  !res.viewableUsers.includes(newEl?.FamilyUserId))
              ) {
                debugger;
                addAccess = true;
                viewAccess = true; // Grant view access if add access is granted
              }

              if (
                !addAccess &&
                (res.viewPrevilege === "any_one" ||
                  res.viewPrevilege === "all_su" ||
                  (res.addableUsers.includes(newEl?.FamilyUserId) &&
                    !res.viewableUsers.includes(newEl?.FamilyUserId)) ||
                  res.viewableUsers.includes(newEl?.FamilyUserId))
              ) {
                debugger;
                viewAccess = true;
              }

              // Override logic only if not already granted
              if (
                !addAccess &&
                (res.addPrevilege === "el_staff" ||
                  res.addPrevilege === "no_one")
              ) {
                debugger;
                addAccess = false;
              }

              if (
                !viewAccess &&
                (res.viewPrevilege === "el_staff" ||
                  res.viewPrevilege === "no_one")
              ) {
                debugger;
                viewAccess = false;
              }

              // Finally set the state
              setHaveAccessAdd(addAccess);
              setHaveAccessView(viewAccess);
            }
          });
          //

          setFamilyDetails(response);
          let famUserID = userUUID ? uuidFind.id : response.FamilyData.id;
          if (userUUID) {
            setFamilyUserId(uuidFind.id);
          } else {
            setFamilyUserId(famUserID);
          }

          let params = {
            userId: famUserID,
            familyId: response.FamilyData.Family.id,
            searchStr: searchValue,
            sort: sortValue,
            order: orderValue,
            limit: limit,
            offset: offset,
            filtBy: filtValue,
            status: expValue,
            logged: famUserID,
          };

          let Max = {
            userId: famUserID,
            familyId: response.FamilyData.Family.id,
            searchStr: searchValue,
            status: expValue,
            logged: famUserID,
          };

          // get savings list
          UserService.getSavingsTotal(Max).then(
            (inner_response) => {
              console.log(inner_response);
              setTotalItems(inner_response.dataCount);
              inner_response.dataCount === 0
                ? setIsEmpty(true)
                : setIsEmpty(false);
            },
            (error) => {}
          );

          // get savings list
          UserService.getSavings(params).then(
            (inner_response) => {
              setSavingsList(inner_response.data.rows);
              setTimeout(() => {
                setLoadingspinner(false);
                setMounted(true); // Set mounted to true after the initial load
              }, 1000);
            },
            (error) => {}
          );
        },
        (error) => {}
      );
    });
  };

  const getSavingsList = (params) => {
    setLoadingspinner(true);

    let Max = { ...params }; // Clone params to avoid modifying it directly
    Max.limit = 9007199254740991; // Update the limit property

    // get all data

    UserService.getSavings(params).then(
      (response) => {
        setSavingsList(response.data.rows);
        setTimeout(() => {
          setLoadingspinner(false);
        }, 250);
      },
      (error) => {}
    );
  };

  const fetchTasks = (page, limitVal) => {
    setLoadingspinner(true);
    const offset1 = (page - 1) * 50;
    let params = {
      userId: familyUserId,
      familyId: familyDetails.FamilyData.Family.id,
      searchStr: searchValue,
      sort: sortValue,
      order: orderValue,
      limit: limitVal,
      offset: offset1,
      filtBy: filtValue,
      status: expValue,
      monthType: monthType,
      logged: familyUserId,
    };

    // get all data
    UserService.getSavings(params).then(
      (response) => {
        setSavingsList(response.data.rows);
        setLoadingspinner(false);
      },
      (error) => {}
    );
  };

  // Clear search
  const clearSearch = (e) => {
    e.preventDefault();
    setShowSearchText(false);
    setSearchStr("");
    setsearchValue("");
    setLoadingspinner(true);
    let params = {
      userId: familyUserId,
      familyId: familyDetails.FamilyData.Family.id,
      searchStr: "",
      sort: sortValue,
      order: orderValue,
      limit: limit,
      offset: offset,
      filtBy: filtValue,
      status: expValue,
      monthType: monthType,
      logged: familyUserId,
    };
    getSavingsList(params);
  };

  // search box
  useEffect(() => {
    if (familyDetails.FamilyData !== undefined) {
      if (searchStr.length === 0) {
        // clearSearch();
        setShowSearchText(false);
        setLoadingspinner(true);
        setSearchStr("");
        setsearchValue("");
        let params = {
          userId: familyUserId,
          familyId: familyDetails.FamilyData.Family.id,
          searchStr: "",
          sort: sortValue,
          order: orderValue,
          limit: limit,
          offset: offset,
          filtBy: filtValue,
          status: expValue,
          monthType: monthType,
          logged: familyUserId,
        };
        getSavingsList(params);
      }
    }
  }, [searchStr]);

  // Search savings
  const savingsSearch = (e) => {
    if (e.key === "Enter" || e.keyCode === 13 || e.which === 13) {
      setShowSearchText(true);
      setLoadingspinner(true);
      let srchStr = e.target.value;
      setSearchStr(e.target.value);
      setsearchValue(srchStr);
      if (srchStr === "") {
        clearSearch(e);
      } else {
        let params = {
          userId: familyUserId,
          familyId: familyDetails.FamilyData.Family.id,
          searchStr: srchStr,
          sort: sortValue,
          order: orderValue,
          limit: limit,
          offset: offset,
          filtBy: filtValue,
          status: expValue,
          monthType: monthType,
          logged: familyUserId,
        };
        getSavingsList(params);
      }
    }
  };

  // Search modal
  const handleCloseSearch = () => setShowSearch(false);
  const handleShowSearch = () => setShowSearch(true);

  //onchange in filter by & filter by value--
  const handleChange = (val) => {
    if (val === "all") {
      setCheckAll(true);
      setMonthType("all");
      setexpValue("");
      let params = {
        familyId: familyDetails.FamilyData.Family.id,
        userId: familyUserId,
        searchStr: searchValue,
        sort: sortValue,
        order: orderValue,
        limit: limit,
        offset: offset,
        filtBy: val,
        status: "",
        monthType: "all",
        logged: familyUserId,
      };
      getSavingsList(params);
    }
  };

  //onchange in filter by & filter by value--
  const savingsSort = (val) => {
    setorderValue(val);
    let params = {
      familyId: familyDetails.FamilyData.Family.id,
      userId: familyUserId,
      searchStr: searchValue,
      sort: sortValue,
      order: val,
      limit: limit,
      offset: offset,
      filtBy: filtValue,
      status: expValue,
      monthType: monthType,
      logged: familyUserId,
    };
    getSavingsList(params);
  };

  const dropdownRef = useRef(null); // Ref for dropdown
  const buttonRef = useRef(null); // Ref for the dropdown button
  const sortRef = useRef(null); // Ref for the dropdown button

  const [selectedSort, setSelectedSort] = useState(null); // Selected option for sort dropdown
  const [isSortDropdown, setIsSortDropdown] = useState(false);

  const toggleDropdown = () => {
    setIsDropdownOpen((prev) => !prev); // Toggle the dropdown state
  };

  const closeDropdown = () => {
    setIsDropdownOpen(false); // Close the main dropdown
    setIsDropdownOpen1(false); // Close second dropdown
  };

  const toggleDropdownSort = () => {
    setIsSortDropdown((prev) => !prev); // Toggle the dropdown state
  };

  const closeDropdownSort = () => {
    setIsSortDropdown(false);
    setIsDropdownOpen2(false);
  };

  useEffect(() => {
    // Handler to detect clicks outside of the dropdown
    const handleClickOutside = (event) => {
      // handle filter dropdown
      if (
        dropdownRef.current &&
        !dropdownRef.current.contains(event.target) &&
        buttonRef.current &&
        !buttonRef.current.contains(event.target)
      ) {
        closeDropdown();
      }

      // handle sort dropdown
      if (sortRef.current && !sortRef.current.contains(event.target)) {
        closeDropdownSort();
      }
    };

    // Bind the event listener for clicks outside
    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      // Cleanup the event listener on component unmount
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // Update screen width on resize
  useEffect(() => {
    const handleResize = () => setScreenWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);

    // Cleanup listener on component unmount
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const [pageSize, setPageSize] = useState(50); // Default value is 50

  const handlePageSizeChange = (event) => {
    const selectedValue = parseInt(event.target.value, 10); // Get the selected value as a number
    setPageSize(selectedValue); // Update the state
    setlimit(selectedValue);

    fetchTasks(currentPage, selectedValue);
    setCurrentPage(1); // Reset to page 1 after limit change
  };

  useEffect(() => {
    if (mounted) {
      fetchTasks(currentPage, limit);
    }
  }, [currentPage]);

  const totalPages = Math.ceil(totalItems / limit);

  const handlePageChange = (newPage) => {
    setCurrentPage(newPage);
  };

  const hexToString = (hex) => {
    return `****${Buffer.from(hex, "hex").toString("utf8").slice(-4)}`;
  };

  return (
    <>
      <Container
        fluid
        ref={myRef}
        style={{ minHeight: "calc(100vh - 17rem)", marginBottom: "6rem" }}
        className="d-flex flex-column"
      >
        <ToastBlockContainer
          successToast={successToast}
          showToast={showToast}
          setShowToast={setShowToast}
          toastMessage={toastMessage}
        />

        <>
          {loadingspinner ? (
            <>
              <Loading />
            </>
          ) : (
            <>
              {
                <Row className="row align-items-start justify-content-md-end gy-xl-0 gx-2 gx-xl-3 mb-4">
                  <Col>
                    <h1 className="lh-base mb-0">{title}</h1>
                  </Col>

                  <>
                    {/* sort  */}
                    <Col
                      xs="auto"
                      className="position-relative"
                      ref={sortRef} // Ref to track button for outside clicks
                    >
                      <button
                        className={`border-white btn btn-white d-xl-flex align-items-xl-center shadow position-relative ${
                          isSortDropdown ? "dropdown-arrow" : ""
                        }`}
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        onClick={toggleDropdownSort} // Toggle dropdown on click
                        aria-expanded={isSortDropdown}
                      >
                        <i className="fa-solid fa-sm fa-sort lh-1 align-middle"></i>
                        <span className="text-dark ms-md-2 d-none d-xl-block">
                          Sort by
                        </span>
                      </button>
                      {/* main dropdown  */}
                      <ul
                        className={`dropdown-menu dropdown-parent mt-2 ${
                          isSortDropdown ? "show" : ""
                        }`}
                        ref={dropdownRef}
                        style={{
                          boxShadow:
                            "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        }}
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li>
                          {sortMain.map((option) => (
                            <div
                              key={option.value}
                              className="dropdown-item"
                              style={{
                                cursor: "pointer",
                                color:
                                  selectedSort &&
                                  selectedSort.value === option.value
                                    ? "#020617"
                                    : "",
                                backgroundColor:
                                  selectedSort &&
                                  selectedSort.value === option.value
                                    ? "#36f1cc"
                                    : "",
                              }}
                              onClick={() => {
                                setSelectedSort(option);
                                // giftcardSort(option.value);
                                // closeDropdownSort();
                                setIsDropdownOpen2(true);
                              }}
                            >
                              {option.label}
                            </div>
                          ))}
                        </li>
                      </ul>
                      {isDropdownOpen2 && (
                        <ul
                          className={`dropdown-menu dropdown-child mt-2 show`}
                          style={{
                            boxShadow:
                              "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                            top: screenWidth > 767 ? "3.5rem" : "12.75rem",
                            left: screenWidth > 1200 ? "16rem" : "",
                            right:
                              screenWidth > 1200
                                ? ""
                                : screenWidth < 1200 && screenWidth > 767
                                ? "4rem"
                                : "0",
                          }}
                          aria-labelledby="dropdownMenuButton"
                        >
                          <div
                            style={{
                              position: "absolute",
                              left: screenWidth > 1200 ? "-14px" : "",
                              right: screenWidth < 1200 ? "-14px" : "",
                              width: "0px",
                              height: "0px",
                              borderLeft: "10px solid transparent",
                              borderRight: "10px solid transparent",
                              borderBottom: "15px solid white",
                              transform:
                                screenWidth < 1200
                                  ? "rotate(-30deg)"
                                  : "rotate(-210deg)",
                              top: "10px",
                              display: screenWidth > 767 ? "" : "none",
                            }}
                          ></div>{" "}
                          {/* Arrow */}
                          <li>
                            {sortOpt.map((option) => (
                              <div
                                key={option.value}
                                className="dropdown-item"
                                style={{
                                  cursor: "pointer",
                                  color:
                                    sortOptSelected &&
                                    sortOptSelected.value === option.value
                                      ? "#020617"
                                      : "",
                                  backgroundColor:
                                    sortOptSelected &&
                                    sortOptSelected.value === option.value
                                      ? "#36f1cc"
                                      : "",
                                }}
                                onClick={() => {
                                  savingsSort(option.value);
                                  setSortOptSelected(option);
                                  closeDropdownSort();
                                }}
                              >
                                {option.label}
                              </div>
                            ))}
                          </li>
                        </ul>
                      )}
                    </Col>

                    {/* filter  */}
                    <Col
                      xs="auto"
                      className="position-relative"
                      ref={buttonRef} // Ref to track button for outside clicks
                    >
                      <button
                        className={`border-white btn btn-white d-xl-flex align-items-xl-center shadow position-relative ${
                          isDropdownOpen ? "dropdown-arrow" : ""
                        }`}
                        type="button"
                        id="dropdownMenuButton"
                        data-bs-toggle="dropdown"
                        onClick={toggleDropdown} // Toggle dropdown on click
                        aria-expanded={isDropdownOpen}
                      >
                        <i className="fa-solid fa-sm fa-sliders-h lh-1 align-middle"></i>
                        <span className="text-dark ms-md-2 d-none d-xl-block">
                          Filters
                        </span>
                      </button>
                      {/* main dropdown  */}
                      <ul
                        className={`dropdown-menu dropdown-parent mt-2 ${
                          isDropdownOpen ? "show" : ""
                        }`}
                        ref={dropdownRef}
                        style={{
                          boxShadow:
                            "rgba(100, 100, 111, 0.2) 0px 7px 29px 0px",
                        }}
                        aria-labelledby="dropdownMenuButton"
                      >
                        <li>
                          {filterOption.map((option) => (
                            <div
                              key={option.value}
                              className="dropdown-item"
                              style={{
                                cursor: "pointer",
                                color:
                                  selectedOption1 &&
                                  selectedOption1.value === option.value
                                    ? "#020617"
                                    : "",
                                backgroundColor:
                                  selectedOption1 &&
                                  selectedOption1.value === option.value
                                    ? "#36f1cc"
                                    : "",
                              }}
                              onClick={() => {
                                setSelectedOption1(option);
                                if (option.value === "all") {
                                  closeDropdown(); // Close dropdown after selecting an option}
                                  handleChange(option.value);
                                } else {
                                  setIsDropdownOpen1(true);
                                  setSelectedFilterType(option.value);
                                }
                              }}
                            >
                              {option.label}
                            </div>
                          ))}
                        </li>
                      </ul>
                    </Col>

                    <Col xs="auto">
                      <Button
                        variant="white"
                        className="d-xl-none border-white shadow"
                        onClick={handleShowSearch}
                      >
                        <i className="fa-solid fa-sm fa-magnifying-glass text-dark lh-1 align-middle"></i>
                      </Button>
                      <InputGroup className="shadow rounded d-none d-xl-flex">
                        <Form.Control
                          type="text"
                          placeholder="Search accounts"
                          value={searchStr}
                          onChange={(e) => setSearchStr(e.target.value)}
                          onKeyDown={savingsSearch}
                          className="border-white"
                        />
                        {!searchStr && (
                          <Button
                            variant="white"
                            className="border-white"
                            type="submit"
                          >
                            <i className="fa-solid fa-sm fa-magnifying-glass text-dark lh-1 align-middle"></i>
                          </Button>
                        )}
                        {searchStr && (
                          <Button
                            variant="white"
                            className="border-white"
                            type="submit"
                            onClick={clearSearch}
                          >
                            <i className="fa-solid fa-sm fa-circle-xmark text-dark lh-1 align-middle"></i>
                          </Button>
                        )}
                      </InputGroup>
                    </Col>
                    {haveAccessAdd && (
                      <Col xs="auto">
                        <Link
                          to={addSavingsURL}
                          className="btn btn-primary d-md-flex align-items-md-center"
                        >
                          <i className="fa-solid fa-sm fa-add lh-1 align-middle"></i>
                          <span className="ms-md-2 d-none d-md-block">
                            Add new
                          </span>
                        </Link>
                      </Col>
                    )}
                  </>
                </Row>
              }

              <p className="sub-title mb-4">
                Should you wish to, you can allow trusted Users to see the
                savings accounts you have and with which Bank these are
                associated to.{" "}
                <span className="d-block">
                  This is more about sharing relevant information and Users
                  cannot access or see your transaction.
                </span>
              </p>

              {haveAccessView ? (
                <section className="bg-white p-4 p-md-5 p-lg-6 rounded-4 shadow h-100">
                  <Row className="gx-3 gy-0 gx-md-4 gx-lg-3 gx-xl-2 gx-xxl-3">
                    <Col
                      sm="6"
                      xs="7"
                      md="4"
                      lg="5"
                      xl="4"
                      xxl="4"
                      className=""
                    >
                      <span className="small fw-semibold fs-17">Category</span>
                    </Col>
                    <Col xl="4" xxl="4" className="d-none d-xl-block">
                      <span className="small fw-semibold fs-17">
                        Account Type
                      </span>
                    </Col>
                    <Col sm="6" xs="6" md="5" lg="4" xl="4" xxl="4">
                      <span className="small fw-semibold fs-17">Provider</span>
                    </Col>
                    <Col sm="7" xs="6" md="6" lg="6" xl="4" xxl="5">
                      <span className="small fw-semibold fs-17">
                        Account Number
                      </span>
                    </Col>
                    <Col
                      md="6"
                      lg="6"
                      xl="4"
                      xxl="5"
                      className="d-none d-md-block"
                    >
                      <span className="small fw-semibold fs-17">
                        Account Details
                      </span>
                    </Col>
                  </Row>
                  <hr className="mt-1 mb-3" />
                  {isEmpty ? (
                    <div className="text-center">
                      <p className="mt-4">
                        You currently have no accounts set up!
                      </p>
                      <Link
                        to={addSavingsURL}
                        className="btn btn-primary btn-lg d-inline-flex align-items-center"
                      >
                        <i className="fa-solid fa-sm fa-add lh-1 align-middle"></i>
                        <span className="ms-md-2 d-none d-md-block">
                          Add new
                        </span>
                      </Link>
                    </div>
                  ) : (
                    <>
                      {savingsList &&
                        savingsList.map((subData, index) => (
                          <React.Fragment key={subData.id}>
                            <Row
                              className="align-items-center gx-3 gy-0 gx-md-4 gx-lg-3 gx-xl-2 gx-xxl-3"
                              onClick={() => viewDetailsRoute(subData.id)}
                              style={{ cursor: "pointer" }}
                            >
                              <Col
                                sm="6"
                                xs="7"
                                md="4"
                                lg="5"
                                xl="4"
                                xxl="4"
                                className=""
                              >
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250 }}
                                  overlay={
                                    <Tooltip id="">
                                      <div className="">
                                        {subData.Category
                                          ? subData.Category.CategoryName ===
                                            "Others"
                                            ? subData.otherCategory
                                            : subData.Category.CategoryName
                                          : "--"}
                                      </div>
                                    </Tooltip>
                                  }
                                >
                                  <div className="small text-dark text-truncate max-width-webkit w-fit">
                                    {subData.Category
                                      ? subData.Category.CategoryName ===
                                        "Others"
                                        ? subData.otherCategory
                                        : subData.Category.CategoryName
                                      : "--"}
                                  </div>
                                </OverlayTrigger>
                              </Col>

                              <Col xl="4" xxl="4" className="d-none d-xl-block">
                                <OverlayTrigger
                                  placement="bottom"
                                  delay={{ show: 250 }}
                                  overlay={
                                    <Tooltip id="">
                                      <div className="">
                                        {subData.SubCategory
                                          ? subData.SubCategory
                                              .subCategoryName === "Others"
                                            ? subData.otherCategory
                                            : subData.SubCategory
                                                .subCategoryName
                                          : "--"}
                                      </div>
                                    </Tooltip>
                                  }
                                >
                                  <div className="small text-dark text-truncate max-width-webkit w-fit">
                                    {subData.SubCategory
                                      ? subData.SubCategory.subCategoryName ===
                                        "Others"
                                        ? subData.otherCategory
                                        : subData.SubCategory.subCategoryName
                                      : "--"}
                                  </div>
                                </OverlayTrigger>
                              </Col>

                              <Col sm="6" xs="6" md="6" lg="4" xl="4" xxl="4">
                                <div className="d-flex align-items-center gap-2">
                                  <div class="img-wrapper img-wrapper-warranty-product flex-shrink-0 d-none d-md-flex">
                                    <img
                                      src={
                                        subData.Supplier &&
                                        subData.Supplier.logo
                                          ? subData.Supplier.logo
                                          : "--"
                                      }
                                      alt="logo"
                                      className="img-fluid w-100 h-100"
                                    />
                                  </div>
                                  <OverlayTrigger
                                    placement="bottom"
                                    delay={{ show: 250 }}
                                    overlay={
                                      <Tooltip id="">
                                        <div className="">
                                          {subData.Supplier &&
                                          subData.Supplier.name
                                            ? subData.Supplier.name === "Others"
                                              ? subData.otherSupplierName
                                              : subData.Supplier.name
                                            : "--"}
                                        </div>
                                      </Tooltip>
                                    }
                                  >
                                    <div className="small  text-dark text-truncate max-width-webkit w-fit">
                                      {subData.Supplier && subData.Supplier.name
                                        ? subData.Supplier.name === "Others"
                                          ? subData.otherSupplierName
                                          : subData.Supplier.name
                                        : "--"}
                                    </div>
                                  </OverlayTrigger>
                                </div>
                              </Col>

                              <Col sm="7" xs="6" md="5" lg="6" xl="4" xxl="5">
                                <div className="d-inline small  text-dark">
                                  {subData.accountNumber
                                    ? hexToString(subData.accountNumber)
                                    : " --"}
                                </div>
                              </Col>
                              <Col
                                sm="5"
                                xs="6"
                                md="6"
                                lg="6"
                                xl="4"
                                xxl="5"
                                className="d-none d-md-block"
                              >
                                <div className="d-inline small  text-dark">
                                  {subData.accountDetails
                                    ? subData.accountDetails
                                    : "--"}
                                </div>
                              </Col>

                              <Col
                                xs="auto"
                                className=" ms-auto d-flex align-items-center gap-lg-2 w-auto"
                              >
                                <Button
                                  className="btn-sm btn-square btn-interactive"
                                  variant="link"
                                  onClick={(event) => {
                                    event.stopPropagation(); // Prevents event from bubbling up
                                    editSavingsUrl(subData.id);
                                  }}
                                  style={{ cursor: "pointer" }}
                                >
                                  <i className="fa-solid fa-sm fa-edit"></i>
                                </Button>
                                <Button
                                  className="btn-sm btn-square btn-interactive"
                                  variant="link"
                                  onClick={() => viewDetailsRoute(subData.id)}
                                  style={{ cursor: "pointer" }}
                                >
                                  <i className="fa-solid fa-sm fa-chevron-right"></i>
                                </Button>
                              </Col>
                            </Row>
                            {index !== savingsList.length - 1 && (
                              <hr className="my-3" />
                            )}
                          </React.Fragment>
                        ))}
                    </>
                  )}

                  {savingsList.length === 0 && !isEmpty && (
                    <>
                      <p className="text-center mt-4">
                        There are no results for the query
                      </p>
                    </>
                  )}

                  {/* pagination  */}
                  <div className="d-sm-flex align-items-center gap-2 justify-content-end mt-7 fs-14 bold-colour pt-3">
                    {/* Page Size Dropdown */}
                    <div className="d-flex align-items-center gap-2 me-3  mb-3 mb-sm-0">
                      <label htmlFor="pageSize">Page Size:</label>
                      <select
                        id="pageSize"
                        value={pageSize} // Bind the state to the select element
                        onChange={handlePageSizeChange}
                        className="form-select p-2 me-2 fs-14"
                        style={{ width: "75px", display: "inline-block" }}
                      >
                        <option value={50}>50</option>
                        <option value={75}>75</option>
                        <option value={100}>100</option>
                        <option value={150}>150</option>
                      </select>
                      <div>
                        Showing <strong>{savingsList.length}</strong> of{" "}
                        <strong>{totalItems}</strong>
                      </div>
                    </div>
                    <div className="d-flex align-items-center gap-2">
                      {/* Previous Button */}
                      <button
                        className="border-0 bg-transparent"
                        onClick={() => handlePageChange(currentPage - 1)}
                        disabled={currentPage === 1}
                      >
                        <i class="fas fa-chevron-left "></i>
                      </button>
                      <div>
                        Page{" "}
                        <strong>{totalPages === 0 ? 0 : currentPage}</strong> of{" "}
                        <strong>{totalPages}</strong>
                      </div>
                      {/* Next Button */}
                      <button
                        className="border-0 bg-transparent"
                        onClick={() => handlePageChange(currentPage + 1)}
                        disabled={currentPage * limit >= totalItems}
                      >
                        <i class="fas fa-chevron-right"></i>
                      </button>
                    </div>
                  </div>
                </section>
              ) : (
                <section
                  className="bg-white p-4 p-md-5 p-lg-6 rounded-4 shadow d-flex align-items-center justify-content-center"
                  style={{ height: "20rem" }}
                >
                  You have no access to view this page. Please check with the
                  Main User for the access
                </section>
              )}
            </>
          )}
        </>

        {/* Search for mobile */}
        <Modal show={showSearch} onHide={handleCloseSearch}>
          <Modal.Header closeButton>
            <Modal.Title>Search</Modal.Title>
          </Modal.Header>
          <Modal.Body>
            <InputGroup className="rounded shadow">
              <Form.Control
                type="text"
                placeholder="Search accounts"
                value={searchStr}
                onChange={(e) => setSearchStr(e.target.value)}
                onKeyDown={savingsSearch}
                className="border-white"
              />
              {!searchStr && (
                <Button variant="white" className="border-white" type="submit">
                  <i className="fa-solid fa-sm fa-magnifying-glass text-dark lh-1 align-middle"></i>
                </Button>
              )}
              {searchStr && (
                <Button
                  variant="white"
                  className="border-white"
                  type="submit"
                  onClick={clearSearch}
                >
                  <i className="fa-solid fa-sm fa-circle-xmark text-dark lh-1 align-middle"></i>
                </Button>
              )}
            </InputGroup>
          </Modal.Body>
        </Modal>
      </Container>
    </>
  );
};

export default Savings;
